const RELAY_PATH = '/dubbletrack-sync';
const ENVELOPE = 'dubbletrackSync';

// BroadcastChannel stops at the origin, so a page on the station's site reaches a player
// on its own domain through a hidden frame of that domain, which sits on the channel there.
export class SyncRelay {
  _frame = null;
  _origin = null;
  _ready = false;
  _queued = [];
  _onMessage = null;
  _messageHandler = null;

  constructor(playerUrl, onMessage) {
    this._origin = new URL(playerUrl).origin;
    this._onMessage = onMessage;

    this._messageHandler = (event) => {
      if (event.origin !== this._origin || event.source !== this._frame?.contentWindow) return;
      let data = event.data?.[ENVELOPE];
      if (!data) return;
      if (data.type === 'relay-ready') {
        this._ready = true;
        this._queued.splice(0).forEach((message) => this.post(message));
        return;
      }
      this._onMessage(data);
    };
    window.addEventListener('message', this._messageHandler);

    let frame = document.createElement('iframe');
    frame.src = `${this._origin}${RELAY_PATH}?origin=${encodeURIComponent(window.location.origin)}`;
    frame.setAttribute('aria-hidden', 'true');
    frame.setAttribute('tabindex', '-1');
    frame.style.cssText = 'position:absolute;width:0;height:0;border:0;visibility:hidden;';
    document.body.appendChild(frame);
    this._frame = frame;
  }

  get origin() {
    return this._origin;
  }

  post(message) {
    if (!this._ready) {
      this._queued.push(message);
      return;
    }
    this._frame?.contentWindow?.postMessage({ [ENVELOPE]: message }, this._origin);
  }

  destroy() {
    window.removeEventListener('message', this._messageHandler);
    this._frame?.remove();
    this._frame = null;
  }
}
